<div class="container-fluid mt-3 ">
    <div class="row p-3 d-flex justify-content-center">

        <h1 class="text-center mb-3"> Mon Laboratoire</h1>
        <div class="col-12 col-md-6 col-xl-4 justify-content-center border rounded py-5">
            <div class="row">
                <!-- <span class="d-flex col fst-italic justify-content-end align-items-center">Nom</span> -->
                <img [src]="getLabImg()">
                <span class="col text-start display-5">{{Agency.Name}}</span>
            </div>
            <div class="row justify-content-center">
                <mat-divider class="col m-3 px-1"></mat-divider>
            </div>
            <div class="row">
                <div class=" d-flex col fst-italic justify-content-end align-items-center">Email</div>
                <div class="col">
                    <span class="col text-start">{{Agency.Email}}</span>
                    <button mat-icon-button [cdkCopyToClipboard]="Agency.Email">
                        <mat-icon class="material-symbols-outlined">
                            content_copy
                        </mat-icon>
                    </button>
                </div>
            </div>
            <div class="row justify-content-center">
                <mat-divider class="col m-3 px-1"></mat-divider>
            </div>
            <div class="row">
                <span class="d-flex col fst-italic justify-content-end align-items-center">Téléphone</span>
                <span class="col text-start">{{Agency.Phone}}</span>
            </div>
            <div class="row justify-content-center">
                <mat-divider class="col m-3 px-1"></mat-divider>
            </div>
            <div class="row">
                <span class="d-flex col fst-italic justify-content-end align-items-center">Adresse</span>
                <span class="col text-start">{{Agency.Address}} <br />{{Agency.ZipCode}} {{Agency.City}}</span>
            </div>
        </div>
    </div>
</div>